import { Controller, useFormContext } from 'react-hook-form';
import FileUploadField from './FileUploadField';

/**
 * Controlled file upload input for react-hook-form
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {Object} [props.rules]
 * @param {string} [props.buttonText='Upload']
 * @param {Object} [props.sx]
 * @param {boolean} [props.autoUpload=false]
 * @param {boolean} [props.disabled=false]
 * @param {string} [props.buttonClass='btn cta-outlined-btn']
 * @param {string} [props.buttonIcon]
 * @param {boolean} [props.showPreview=false]
 * @param {'before'|'after'} [props.previewPosition='after']
 * @param {string} [props.previewText='view']
 * @param {Object} [props.previewLinkProps]
 *
 * @example value shapes
 * autoUpload: { id: number|null, url: string }
 * manual: { file: File }
 */
export default function ControlledFileUpload(props: any) {
  const { control, trigger } = useFormContext();
  const { name, rules } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <FileUploadField
          {...props}
          value={field.value}
          onChange={field.onChange}
          trigger={trigger}
        />
      )}
    />
  );
}
